import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@app/shared/services/auth.service';
import { Observable, Subject, of } from 'rxjs';
import { first, map, takeUntil, tap } from 'rxjs/operators';
import { MunicipalityStoreConfig } from './models/municipality-management';
import { MunicipalityManagementApiService } from './services/municipality-management-api.service';
import { MunicipalityManagementService } from './services/municipality-management.service';
import { ExterneAppsFacadeService } from './services/externe-apps-facade.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';

@Component({
  selector: 'app-municipality-management',
  templateUrl: './municipality-management.component.html',
  styleUrls: ['./municipality-management.component.scss'],
})
export class MunicipalityManagementComponent implements OnInit, OnDestroy {
  protected _unsubscribe$: Subject<void> = new Subject<void>();
  public isSaveButtonDisabled$: Observable<boolean> = of(false);
  public isTabEnabled: boolean = false;
  public displayDownloadBtn: boolean;
  public tabIndex: number = 0;

  public municipalityConfig$: Observable<MunicipalityStoreConfig> = of();

  constructor(
    private _service: MunicipalityManagementService,
    private _apiService: MunicipalityManagementApiService,
    private _authService: AuthService,
    private externeAppsFacadeService: ExterneAppsFacadeService,
    private userMunicipalitiesService: UserMunicipalitiesService
  ) {
    this.displayDownloadBtn = !!this._authService.permissions.MUNICIPALITY_MANAGEMENT_DOWNLOAD;
  }

  public ngOnDestroy(): void {
    this._service.resetChanges();
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
    this.externeAppsFacadeService.ngOnDestroy();
  }

  public ngOnInit(): void {
    this.municipalityConfig$ = this._service.initializeConfigurationStore().pipe(
      takeUntil(this._unsubscribe$),
      tap(() => this.initializeDamageReportTab())
    );

    this.isSaveButtonDisabled$ = this._service.formValidation().pipe(map((isFormValid: boolean) => !isFormValid));
    this.userMunicipalitiesService.currentMunicipality$.pipe(takeUntil(this._unsubscribe$)).subscribe((municipality) => {
      this.externeAppsFacadeService.externeAppsDispatch(municipality.guid);
    });
  }

  public cancel(): void {
    this._service.resetChanges();
  }

  public showSaveModal(): void {
    this._service.saveChanges().pipe(first()).subscribe();
  }

  public downloadReport(): void {
    this._apiService.getMunicipalityReport().pipe(first()).subscribe();
  }

  private initializeDamageReportTab(): void {
    this.isTabEnabled = this._service.isDmgReportTabEnabled;
  }

  public hide(tabIndexValue: number): void {
    this.tabIndex = tabIndexValue;
  }
}
